import { RootState } from "../../../rootState";
import { queriableWmsBaselineLayerSelector } from "../../../common/selector/layerSelector";

export const layersSelector = (state: RootState): string => {
    return queriableWmsBaselineLayerSelector(state)
        .map((value) => value.name)
        .toString();
};
